/**
 * WeekSelector Component
 * 주차 선택 컴포넌트 (현재 주차 기준 이전 8주차까지 선택 가능)
 */
import React from 'react';
import './WeekSelector.css';

interface WeekOption {
    label: string;
    startDate: string;
    endDate: string;
}

interface WeekSelectorProps {
    value: { startDate: string; endDate: string };
    onChange: (startDate: string, endDate: string) => void;
}

const WeekSelector: React.FC<WeekSelectorProps> = ({ value, onChange }) => {
    const generateWeekOptions = (): WeekOption[] => {
        const options: WeekOption[] = [];
        const today = new Date();
        
        // 현재 주의 수요일 찾기
        const currentDay = today.getDay();
        const diffToWed = (currentDay + 7 - 3) % 7;
        const currentWed = new Date(today);
        currentWed.setDate(today.getDate() - diffToWed);
        
        // 현재 주차부터 이전 8주차까지 (총 9주)
        for (let i = 0; i < 9; i++) {
            const wed = new Date(currentWed);
            wed.setDate(currentWed.getDate() - (i * 7));
            
            const tue = new Date(wed);
            tue.setDate(wed.getDate() + 6);
            
            // 주차 번호 계산 (ISO 8601 기준)
            const weekNum = getWeekNumber(wed);
            const year = wed.getFullYear().toString().slice(2);
            
            const formatDate = (d: Date) => {
                const yy = d.getFullYear().toString().slice(2);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                return `${yy}.${mm}.${dd}`;
            };
            
            options.push({
                label: `W${weekNum}(${formatDate(wed)}~${formatDate(tue)})`,
                startDate: wed.toISOString().split('T')[0],
                endDate: tue.toISOString().split('T')[0]
            });
        }
        
        return options;
    };
    
    // ISO 8601 주차 번호 계산
    const getWeekNumber = (date: Date): number => {
        const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = d.getUTCDay() || 7;
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        return weekNo;
    };
    
    const weekOptions = generateWeekOptions();
    
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = weekOptions.find(opt => opt.startDate === e.target.value);
        if (selectedOption) {
            onChange(selectedOption.startDate, selectedOption.endDate);
        }
    };
    
    return (
        <div className="week-selector">
            <select
                id="weekSelect"
                className="form-input week-select"
                value={value.startDate}
                onChange={handleChange}
            >
                {weekOptions.map((option) => (
                    <option key={option.startDate} value={option.startDate}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default WeekSelector;
